import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import useLogin from './hooks';
import Form from '../../../components/molecules/forms';
import Button from '../../../components/molecules/buttons';
import AuthContainer from '../index';

function Login(): React.ReactElement {
  const {
    isLoading, formik,
  } = useLogin();
  return (
    <AuthContainer
      title="Login"
      description="Your one-stop solution for vending management!"
      askText={['Dont have an account?', 'Signup!']}
      askLink="/signup"
    >
      <form
        aria-label="form"
        onSubmit={formik.handleSubmit}
        className="form-container"
      >
        <Form.Default
          id="username"
          label="Username"
          placeholder="Enter username"
          value={formik.values.username}
          onChange={formik.handleChange}
          className="mb-4"
          isInvalid={formik.touched.username && !!formik.errors.username}
          errorMsg={formik.errors.username}
          onBlur={formik.handleBlur}
          validation
        />
        <Form.Default
          id="password"
          label="Password"
          placeholder="Enter password"
          value={formik.values.password}
          onChange={formik.handleChange}
          className="mb-4"
          isInvalid={formik.touched.password && !!formik.errors.password}
          errorMsg={formik.errors.password}
          onBlur={formik.handleBlur}
          type="password"
          validation
        />
        <div className="mt-5">
          <Button.Default
            id="submitLogin"
            type="submit"
            label="Login"
            className="fw-bold"
            loading={isLoading}
          />
        </div>
      </form>
      <Link
        className="fz-14 border-0 text-decoration-none text-secondary mt-3"
        to="/forgot-password"
      >
        Forgot Password?
      </Link>
    </AuthContainer>
  );
}

export default Login;
